import axios from 'axios'
import { BASE_URL, TIMEOUT } from "./config";

const service = axios.create({
    baseURL: BASE_URL,
    timeout: TIMEOUT
})

export default service;